//Bundle Price Switch
document.addEventListener('change', function(event) {
  if (!event.target.matches('.bundle_radio_d1')) return;
  var value = event.target.value;
  var productSection = event.target.closest('.product-section');
  if (!productSection) return;
  var price1 = productSection.querySelector('[data-bundle-price-wrapper="1"]');
  var price2 = productSection.querySelector('[data-bundle-price-wrapper="2"]');
  if (!price1 || !price2) return;
  if (value === '1') {
    price1.style.display = '';
    price2.style.display = 'none';
  }
  if (value === '2') {
    price1.style.display = 'none';
    price2.style.display = '';
  }
});

//Bundle Add to Cart
